import { VerificationAttribute } from 'dashboard/lib/case-layouts/types';
import { Verification } from 'dashboard/models/verification';
import { ModuleResource } from 'dashboard/modules/Resource';
import { ApiModel } from 'lib/interfaces/api';

export interface ModuleResourceVerification extends ModuleResource {
  'field-key': 'verifications';
  'verification-type': Verification['type'];
  'verification-templates': string[];
}

export interface ModuleResourceVerificationAamva extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationAamva;
}

export interface ModuleResourceVerificationDatabase extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabase;
}

export interface ModuleResourceVerificationDatabaseBusiness extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabaseBusiness;
}

export interface ModuleResourceVerificationDatabaseEcbsv extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabaseEcbsv;
}

export interface ModuleResourceVerificationDatabasePhoneCarrier extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabasePhoneCarrier;
}

export interface ModuleResourceVerificationDatabaseSerpro extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabaseSerpro;
}

export interface ModuleResourceVerificationDatabaseTin extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDatabaseTin;
}

export interface ModuleResourceVerificationDocument extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationDocument;
}

export interface ModuleResourceVerificationEmailAddress extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationEmailAddress;
}

export interface ModuleResourceVerificationGovernmentId extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationGovernmentId;
  attributes: GovernmentIdVerificationModuleAttribute[];
}

export enum GovernmentIdVerificationModuleAttribute {
  Photos = 'photos',
  Id = 'id',
  FullName = 'full_name',
  BirthDate = 'birth_date',
  IssuingCountry = 'issuing_country',
  IssueDate = 'issue_date',
  ExpirationDate = 'expiration_date',
  FromReusablePersona = 'from_reusable_persona',
  CaptureMethod = 'capture_method',
  CaptureMethodBack = 'capture_method_back',
  Address = 'address',
  Nationality = 'nationality',
  Checks = 'checks',
  FilesNormalized = 'files_normalized',
  DocumentNumber = 'document_number',
  Sex = 'sex',
  // For some EU Residence Permits.
  Remarks = 'remarks',
  VehicleClasses = 'vehicle_classes',
  VisaStatus = 'visa_status',
}

export interface ModuleResourceVerificationGovernmentIdNfc extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationGovernmentIdNfc;
}
export interface ModuleResourceVerificationMobileDriversLicense extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationMobileDriversLicense;
}

export interface ModuleResourceVerificationPhoneNumber extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationPhoneNumber;
}

export interface ModuleResourceVerificationSelfie extends ModuleResourceVerification {
  'verification-type': ApiModel.VerificationSelfie;
  attributes: SelfieVerificationModuleAttribute[];
}

export enum SelfieVerificationModuleAttribute {
  Photos = 'photos',
  FromReusablePersona = 'from_reusable_persona',
  CaptureMethod = 'capture_method',
  CaptureMethodLeft = 'capture_method_left',
  CaptureMethodRight = 'capture_method_right',
  Checks = 'checks',
}

export type ResourceVerificationAttributes =
  | GovernmentIdVerificationModuleAttribute
  | SelfieVerificationModuleAttribute
  // TODO(brandon): migrate over verification attributes rather than union typing them here
  | VerificationAttribute;

export type ResourceVerificationModules =
  | ModuleResourceVerificationAamva
  | ModuleResourceVerificationDatabase
  | ModuleResourceVerificationDatabaseBusiness
  | ModuleResourceVerificationDatabaseEcbsv
  | ModuleResourceVerificationDatabasePhoneCarrier
  | ModuleResourceVerificationDatabaseSerpro
  | ModuleResourceVerificationDatabaseTin
  | ModuleResourceVerificationDocument
  | ModuleResourceVerificationEmailAddress
  | ModuleResourceVerificationGovernmentId
  | ModuleResourceVerificationGovernmentIdNfc
  | ModuleResourceVerificationMobileDriversLicense
  | ModuleResourceVerificationPhoneNumber
  | ModuleResourceVerificationSelfie;
